
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "chat",
  "title": "In-built Chat",
  "sidebar_label": "In-built Chat"
};
const slug = 'chat';
const tableOfContents = [{
  "title": "Chat Feature",
  "slug": "chat-feature",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <_Heading level={2} id={"chat-feature"} nextElement={{
      "type": "paragraph"
    }}>Chat Feature</_Heading>
    <p>{`Our platform includes a chat feature that allows users to communicate with each other in real-time. This feature is similar to WhatsApp and provides a variety of features and options for personal and private communication.`}</p>
    <p>{`Users can initiate a chat with a seller, account, tutor profile, or other user from the order details, listing, or profile page. To start a chat, simply tap on the user’s profile or listing and select the chat option. This will open a new chat window where you can send messages and engage in conversation.`}</p>
    <p>{`Using the chat feature, users can:`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Send and receive messages, share images and other media, and engage in conversation with other users.`}</li>
      <li parentName="ul">{`Attach additional private photos and documents related to the listings or other content.`}</li>
      <li parentName="ul">{`Send external links, such as Google Maps or web links, to share additional information or resources.`}</li>
      <li parentName="ul">{`Receive push notifications for new chats and replies.`}</li>
    </ul>
    <p>{`The chat feature is a convenient and easy way for users to communicate with each other and facilitate transactions within the platform. It helps to build trust and create a sense of community among users.`}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
